

export class DragDropService{
    private _$content:JQuery;
    private _$header:JQuery;
    private _$footer:JQuery;

    public get $header(){
        if(this._$header==null)
            this._$header=jQuery('.pdfHeader');

        return this._$header;
    }

    public get $content(){
        if(this._$content==null)
            this._$content=jQuery('.pdfContent');

        return this._$content;
    }

    public get $footer(){
        if(this._$footer==null)
            this._$footer=jQuery('.pdfFooter');

        return this._$footer;
    }

    private static _instance:DragDropService;
    public static Instance(){
        if(DragDropService._instance==null)
            DragDropService._instance=new DragDropService();
        return DragDropService._instance;
    }

    private IsWithinContainer(event:any,container:JQuery):boolean
    {
        let x:number=event.pageX;
        let y:number=event.pageY;
        let pageOffset=container.offset();
        let width=container.width();
        let height=container.height();
        return  x>pageOffset.left&&x<=pageOffset.left+width&&y>pageOffset.top&&y<pageOffset.top+height;

    }

    public GetDropTarget(event: any):{$target:JQuery,targetId:SectionOptionsEnum} {
        if(this.IsWithinContainer(event,this.$content))
            return { $target: this.$content,targetId:SectionOptionsEnum.content};

        if(this.IsWithinContainer(event,this.$header))
            return { $target: this.$header,targetId:SectionOptionsEnum.header};

        if(this.IsWithinContainer(event,this.$footer))
            return { $target: this.$footer,targetId:SectionOptionsEnum.footer};

        return null;

    }

    public GetRelativePosition(clientX: number, clientY: number, $target: JQuery):{x:number,y:number} {
        let offset=$target.offset();
        return {
            x:clientX-offset.left,
            y:clientY-offset.top
        }
    }

}

export enum SectionOptionsEnum{
    content='content',
    footer='footer',
    header='header',
    control='control'
}




